import { createFileRoute } from '@tanstack/react-router';
import { getGetCompanyDocumentByIdQueryOptions } from '@area-restrita/api-client/endpoints/company-document/company-document.gen';

import PageContainer from '@/components/layout/PageContainer';
import RequestChanges from '@/modules/documents/pages/request-changes';

export const Route = createFileRoute(
  '/_authenticated/_system/documents/$companyDocumentPublicId/request-changes/',
)({
  head: () => ({
    meta: [{ title: 'Solicitar Alterações no Documento da Empresa' }],
  }),
  loader: async ({
    params: { companyDocumentPublicId },
    context: { queryClient },
  }) => {
    const companyDocument = await queryClient.ensureQueryData({
      ...getGetCompanyDocumentByIdQueryOptions(companyDocumentPublicId),
      gcTime: 0,
      revalidateIfStale: true,
    });

    return companyDocument;
  },
  component: function RequestChangesPage() {
    const companyDocument = Route.useLoaderData();

    return (
      <PageContainer
        title={`Solicitar alterações: ${companyDocument?.name}`}
        withSeparator
      >
        <RequestChanges companyDocument={companyDocument} />
      </PageContainer>
    );
  },
});
